var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"a11y-tab",rawName:"v-a11y-tab:tab-line",arg:"tab-line"}]},[_c('router-link',{staticClass:"off-default-focus",attrs:{"to":_vm.path}},[_c('div',{staticClass:"logo"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }